import(/* webpackMode: "eager" */ "/var/www/smartguy/node_modules/.pnpm/next@15.5.7_react-dom@19.1.1_react@19.1.1__react@19.1.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/smartguy/src/app/(Guest)/pages/[slug]/components/InfoPages.jsx");
